import { dataHooks } from '@wix/data-hooks'

export const wixStudioWelcomeAnimationDataHooks = dataHooks<{
  root: {}
}>('wix-studio-welcome-animation')
